import { render } from "./App.vue?vue&type=template&id=69c9fd96"
const script = {}

import "./App.vue?vue&type=style&index=0&id=69c9fd96&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__